import React from "react";
import { Collapse, ControlGroup, Tag } from "@blueprintjs/core";
import InvestigationCard from "./InvestigationCard";

import { inject, observer } from "mobx-react";

class Investigation extends React.Component {
  state = { collapse: true };

  renderShort = () => {
    if (!this.props.data || !this.props.data.length) {
      return (
        <Tag minimal large>
          No investigations added.
        </Tag>
      );
    }
    let inv = this.props.data.map((each) => each.type);
    let txt = inv.join(", ");
    return (
      <Tag minimal large multiline>
        {txt}
      </Tag>
    );
  };
  renderHeading = () => {
    return (
      <ControlGroup>
        <Tag
          large
          intent="primary"
          interactive
          onClick={() => this.props.onInv()}
        >
          Procedures
        </Tag>
        {!this.state.collapse ? (
          this.renderShort()
        ) : (
          <Tag
            icon="plus"
            minimal
            large
            interactive
            onClick={() => this.props.onSearch("inv", "investigations")}
          ></Tag>
        )}{" "}
      </ControlGroup>
    );
  };
  renderInvestigations = () => {
    if (!this.props.data || !this.props.data.length) {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag minimal large>
            No investigations added.
          </Tag>
        </ControlGroup>
      );
    }
    return this.props.data.map((each) => {
      return (
        <InvestigationCard
          invLinkDisable={this.props.invLinkDisable}
          genPdf={this.props.genPdf}
          openInvDrawer={this.props.openInvDrawer}
          horizontal={this.props.horizontal}
          data={each}
          update={(invId, key, value) =>
            this.props.update("INVESTIGATION", invId, key, value)
          }
          remove={(invId) => this.props.remove(invId)}
        />
      );
    });
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "start",
          justifyContent: "left",
          padding: `${this.props.horizontal ? "0px" : "10px"}`,
        }}
      >
        {this.renderHeading()}
        <Collapse isOpen={this.state.collapse}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {this.renderInvestigations()}
          </div>
        </Collapse>
      </div>
    );
  }
}
export default inject(
  "bookingStore",
  "authStore",
  "billingStore",
  "patientStore",
  "listStore"
)(observer(Investigation));
